import { PRINTABLE_DELIVERY_NOTE_STATUSES } from 'commons/constants';
import { DeliveryNoteStatusEnum } from 'commons/enums';

export const DELIVERY_NOTE_LIST_DEFAULT_PAGE_SIZE = 100;

export const DELIVERY_NOTE_LIST_MOBILE_BREAKPOINT = 599;

export const DELIVERY_NOTE_STATUS_DISPLAY: Record<string, string> = {
  [DeliveryNoteStatusEnum.PENDING]: 'PENDING',
  [DeliveryNoteStatusEnum.READY_PRINT]: 'READY TO PRINT',
  [DeliveryNoteStatusEnum.PRINTED]: 'PRINTED',
  [DeliveryNoteStatusEnum.PENDING_REPRINT]: 'PENDING REPRINT',
  [DeliveryNoteStatusEnum.READY_REPRINT]: 'READY TO REPRINT',
  [DeliveryNoteStatusEnum.REPRINTED]: 'REPRINTED',
  [DeliveryNoteStatusEnum.CANCELLED]: 'CANCELLED',
};

export const PRINTABLE_STATUSES = PRINTABLE_DELIVERY_NOTE_STATUSES;

export const DELIVERY_NOTE_STATUS_BADGE_COLORS: Record<
  string,
  { bg: string; color: string }
> = {
  [DeliveryNoteStatusEnum.PENDING]: { bg: '#E5E5E5', color: '#525252' },
  [DeliveryNoteStatusEnum.PENDING_REPRINT]: { bg: '#E5E5E5', color: '#525252' },
  [DeliveryNoteStatusEnum.READY_PRINT]: { bg: '#D1FAE5', color: '#065F46' },
  [DeliveryNoteStatusEnum.READY_REPRINT]: { bg: '#D1FAE5', color: '#065F46' },
  [DeliveryNoteStatusEnum.PRINTED]: { bg: '#DBEAFE', color: '#1E40AF' },
  [DeliveryNoteStatusEnum.REPRINTED]: { bg: '#DBEAFE', color: '#1E40AF' },
  [DeliveryNoteStatusEnum.CANCELLED]: { bg: '#FEE2E2', color: '#991B1B' },
};
